import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

const container = document.querySelector('.featured-slider');

export const mainFeaturedSlider = () => {
	container &&
		new Swiper(container, {
			modules: [Autoplay, Pagination],
			slidesPerView: 1,
			allowTouchMove: true,
			grabCursor: true,
			spaceBetween: 20,
			loop: true,
			autoplay: {
				delay: 3000,
			},
			breakpoints: {
				576: {
					slidesPerView: 'auto',
					spaceBetween: 20,
					loop: false,
				},
				1024: {
					slidesPerView: 3,
					spaceBetween: 38,
				},
			},
			pagination: {
				el: container?.querySelector('.swiper-pagination'),
				clickable: true,
			},
		});
};
